<div class="login-page">
  <div class="login-container">
    <div class="bottom-container">
      <img src="assets/img/ADM_Logo.png" alt="ADM logo">
    </div>
    <div class="top-container">
      <img src="assets/img/MatrixNutri-logo.svg" class="login-logo" alt="logo">
      <img src="assets/img/MatrixNutri-title.svg" class="login-title" alt="MatrixNutri">
      <button
        pButton
        fxFlex="0 1 auto"
        type="submit" id="login" name="login"
        class="button-login-page"
        [disabled]="loginDisable"
        (click)="onClick()"
        label="{{'label.user.login.connect' | translate}}"></button>
    </div>
  </div>
</div>
